<template>
  <v-container fluid>
    <template v-if="!horizontal">
      <h2>Quick Look</h2>
      <p>Horizon: {{ horizon }} years</p>
      <h3 v-if="yearlyValues.length">
        First Year {{ yearlyValues[0].year ? `(${yearlyValues[0].year})` : "" }}
      </h3>
      <p v-for="(item, i) in firstYear.values" :key="`${i},${item}`">
        {{ item.title }}: {{ item.value }} {{ item.suffix }}
      </p>
      <h3>
        Last Year
        {{ lastYear.year ? `(${lastYear.year})` : "" }}
      </h3>
      <p v-for="(item, i) in lastYear.values" :key="`l-${i},${item}`">
        {{ item.title }}: {{ item.value }} {{ item.suffix }}
      </p>
      <v-select
        v-model="selectedYear"
        :items="dropdownItem"
        item-text="text"
        item-value="value"
        filled
        label="Select Year"
        return-object
      ></v-select>
      <template v-if="selectedYear">
        <h3>{{ selectedYear.text }}</h3>
        <p v-for="(item, index) in selectedYear.value" :key="`s + ${index},${item}`">
          {{ item.title }}: {{ item.value }} {{ item.suffix }}
        </p>
      </template>
    </template>
    <template v-else>
      <v-row>
        <v-col cols="6" sm="2" md="2">
          <h2>Quick Look</h2>
          <p>Horizon: {{ horizon }} years</p>
          <p v-if="date" class="text-caption">{{ date }}</p>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="6" sm="2" md="2">
          <v-select
            v-model="selectedYear"
            :items="dropdownItem"
            item-text="text"
            item-value="value"
            filled
            label="Select Year"
            return-object
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h3 v-if="yearlyValues.length">
            First Year {{ yearlyValues[0].year ? `(${yearlyValues[0].year})` : "" }}
          </h3>
          <p v-for="(item, i) in firstYear.values" :key="`${i},${item}`">
            {{ item.title }}: {{ item.value }} {{ item.suffix }}
          </p>
        </v-col>
        <v-col>
          <h3>
            Last Year
            {{ lastYear.year ? `(${lastYear.year})` : "" }}
          </h3>
          <p v-for="(item, i) in lastYear.values" :key="`l-${i},${item}`">
            {{ item.title }}: {{ item.value }} {{ item.suffix }}
          </p>
        </v-col>
        <v-col>
          <template v-if="selectedYear">
            <h3>{{ selectedYear.text }}</h3>
            <p v-for="(item, index) in selectedYear.value" :key="`s + ${index},${item}`">
              {{ item.title }}: {{ item.value }} {{ item.suffix }}
            </p>
          </template>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
export default {
  name: "QuickLook",
  components: {},
  mixins: [],
  props: {
    horizon: { type: [String, Number], required: false, default: "" },
    yearlyValues: { type: Array, required: false, default: () => [] },
    horizontal: { type: Boolean, required: false, default: false },
    date: { type: String, required: false, default: null },
  },
  data() {
    return {
      selectedYear: this.yearlyValues.map((v) => ({ text: v.year, value: v.values }))[0],
    };
  },
  computed: {
    dropdownItem() {
      return this.yearlyValues.map((v) => ({ text: v.year, value: v.values }));
    },
    firstYear() {
      return this.yearlyValues[0];
    },
    lastYear() {
      return this.yearlyValues[this.yearlyValues.length - 1];
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
